<template>
  <div class="t-app__container">
    <heading :title="$t('reset-password-title')" />
    <div class="h-section h-section--no-margin-top">
      <div class="h-grid h-grid--justify-content-center">
        <div class="h-grid__col h-grid__col--sm-10 h-grid__col--md-8">
          <template v-if="passwordReseted">
            <p v-html="$t('reset-password-success')"></p>
            <button class="a-btn-primary-outline" type="button" @click="returnHome">{{ $t('return-btn') }}</button>
          </template>
          <template v-else>
            <s-form ref="form" @submit="resetPassword">
              <p class="m-form-group">
                <label for="password" class="a-form-label" :value="password">
                  {{ $t('new-password-label') }}
                  <span class="m-form-group__note m-form-group__note--small"
                    >{{ $t('user-password-rules') }}
                    <ul>
                      <li>{{ $t('user-password-rule-1') }}</li>
                      <li>{{ $t('user-password-rule-2') }}</li>
                      <li>{{ $t('user-password-rule-3') }}</li>
                    </ul>
                  </span>
                </label>
                <input :value="password" @change="setPassword($event.target.value)" type="password" id="password" class="a-form-control" />
                <span v-if="$v.password.$dirty">
                  <span class="m-form-group__error" v-if="!$v.password.required">{{ $t('error-field-required') }}</span>
                  <span class="m-form-group__error" v-if="!$v.password.isValidPassword">
                    {{ $t('error-create-password-invalid') }}
                  </span>
                </span>
              </p>
              <p class="m-form-group">
                <label for="passwordConfirmation" class="a-form-label" :value="passwordConfirmation">{{ $t('new-password-confirmation-label') }}</label>
                <input :value="passwordConfirmation" @change="setPasswordConfirmation($event.target.value)" type="password" id="passwordConfirmation" class="a-form-control" />
                <span v-if="$v.passwordConfirmation.$dirty">
                  <span class="m-form-group__error" v-if="!$v.passwordConfirmation.required">{{ $t('error-field-required') }}</span>
                  <span class="m-form-group__error" v-if="!$v.passwordConfirmation.isSamePassword">
                    {{ $t('error-password-confirmation-invalid') }}
                  </span>
                </span>
              </p>
              <div class="m-form-ctrl">
                <div class="m-form-ctrl__item">
                  <button class="a-btn-primary" type="submit">
                    {{ $t('reset-password-submit-btn') }}
                  </button>
                </div>
                <div class="m-form-ctrl__item">
                  <router-link :to="{ name: $consts.urls.URL_ACCOUNT_LOGIN }">
                    {{ $t('return-btn') }}
                  </router-link>
                </div>
              </div>
            </s-form>
          </template>
        </div>
      </div>
    </div>

    <div class="t-app__confetti t-app__confetti--01"></div>
    <div class="t-app__dot t-app__dot--large"></div>
    <div class="t-app__confetti t-app__confetti--02"></div>
    <div class="t-app__confetti t-app__confetti--03"></div>
    <div class="t-app__confetti t-app__confetti--04"></div>
    <div class="t-app__dot t-app__dot--medium"></div>
    <div class="t-app__confetti t-app__confetti--05"></div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

import Heading from '@/components/heading'
import SForm from '@/components/form/form'

import UserService from '@/services/user'
import Notification from '@/services/notification'
import LoaderService from '@/services/loader'

import { URL_ACCOUNT_LOGIN } from '@/consts/urls'

import FormHelper from '@/helpers/form'
import i18n from '@/helpers/i18n'

const isValidPassword = value => FormHelper.isValidPassword(value)
const isSamePassword = function(value) {
  return this.password === value
}

export default {
  data() {
    return {
      token: this.$router.currentRoute.query.token,
      email: this.$router.currentRoute.query.email,
      password: '',
      passwordConfirmation: '',
      passwordReseted: false
    }
  },
  components: {
    SForm,
    Heading
  },
  validations: {
    password: {
      required,
      isValidPassword
    },
    passwordConfirmation: {
      required,
      isSamePassword
    }
  },
  methods: {
    resetPassword: async function() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        LoaderService.showLoader()
        try {
          let result = await UserService.resetPassword(this.email, this.password, this.token)

          if (result.status === 500) {
            Notification.showError(i18n.t('error-basic'))
          } else {
            this.passwordReseted = true
          }
        } finally {
          LoaderService.hideLoader()
        }
      }
    },
    returnHome: function() {
      this.$router.push({
        name: URL_ACCOUNT_LOGIN
      })
    },
    setPassword: function(value) {
      this.password = value
      this.$v.password.$touch()
    },
    setPasswordConfirmation: function(value) {
      this.passwordConfirmation = value
      this.$v.passwordConfirmation.$touch()
    }
  }
}
</script>